import script from "./DataGroupChooseShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataGroupChooseShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./DataGroupChooseShareModal.vue?vue&type=style&index=0&id=162ee7a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162ee7a2"]])

export default __exports__